var _path, _line;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMuted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon othersSVGs",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2251 20.1781C15.2251 21.7357 13.6797 23 11.77 23C9.86036 23 8.31502 21.7387 8.31502 20.1781M5.67232 1C5.67232 1 2.21731 2.97413 0.960938 7.48852M17.3696 1C17.3696 1 20.8246 2.97413 22.0809 7.48852M4.67156 19.6147C3.05712 19.6147 1.87928 18.2448 2.2876 16.8427C2.2876 16.8427 4.77319 11.5732 5.42863 8.20669C6.24093 4.03439 8.91778 2.87291 12.0841 2.98271C15.2505 3.09251 17.2071 4.79325 17.9608 8.20709C18.7145 11.6209 21.2965 16.6608 21.2965 16.6608C21.7236 18.1568 20.4641 19.6147 18.746 19.6147H4.67156Z",
    stroke: "currentColor",
    strokeWidth: 1.53,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.7213,
    y1: 1.08612,
    x2: 1.08612,
    y2: 22.9681,
    stroke: "currentColor",
    strokeWidth: 1.53667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/Muted.ceedbecafce0f7f4fffcb966729b867b.svg";
export { ForwardRef as ReactComponent };